import PropTypes from 'prop-types';
import React, {createRef} from 'react';
import GridViewHeaderResizer from "./GridViewHeaderResizer";

class GridViewHeaderCell extends React.Component {
  cellRef = createRef();

  onSort = () => {
    if (this.props.onSort) {
      this.props.onSort(this.props.fieldInfo);
    }
  }

  renderCellContent = (cellProps) => {
    const className = `table_column-header${!!cellProps.allowSort ? "_sortable" : ""}`;

    if (this.props.renderHeaderCell) {
      return this.props.renderHeaderCell(cellProps);
    }

    return (
      <span onClick={cellProps.onSort} className={className}>
        {cellProps.title}
        {cellProps.sortArrow}
      </span>
    );
  };

  render() {
    const title = this.props.overrideTitle || this.props.fieldInfo['Header'].replace(/\|/g, ' ');
    let fieldInfoName = this.props.fieldInfo['Name'];
    const allowSort = this.props.fieldInfo['IsSortable'] && this.props.sortInfo && this.props.onSort;
    const sortArrow = allowSort && this.props.sortInfo.FieldName === this.props.fieldInfo['Name']
      ? this.props.sortInfo.Asc ? '↑' : '↓'
      : "";

    const cellProps = {
      title,
      sortArrow,
      allowSort,
      onSort: this.onSort,
      fieldIndex: this.props.fieldIndex,
      fieldInfo: this.props.fieldInfo
    };

    if (fieldInfoName) {
      fieldInfoName = fieldInfoName.replace(/[^A-Z0-9]/gi, "");
    }

    const cellStyle = this.props.headerCellStyleProvider();
    return (
      <th rowSpan={this.props.fieldInfo.rowSpan || 1} colSpan={this.props.fieldInfo.colSpan || 1} style={cellStyle} name={fieldInfoName} ref={this.cellRef}>
        {this.renderCellContent(cellProps)}
          {this.props.canResize && (
              <GridViewHeaderResizer dataItem={this.props.dataItem} columnName={this.props.fieldInfo['Name']} />
          )}
      </th>
    );
  }
}

GridViewHeaderCell.propTypes = {
  dataItem: PropTypes.object,
  fieldIndex: PropTypes.number,
  fieldInfo: PropTypes.object,
  onSort: PropTypes.func,
  sortInfo: PropTypes.object,
  overrideTitle: PropTypes.string,
  updateStateFlag: PropTypes.any,
  renderHeaderCell: PropTypes.func,
  headerCellStyleProvider: PropTypes.func,
  canResize: PropTypes.bool
};

export default GridViewHeaderCell;